import { render, staticRenderFns } from "./MisTutoriasPage.vue?vue&type=template&id=32af1cba&scoped=true&"
import script from "./MisTutoriasPage.vue?vue&type=script&lang=js&"
export * from "./MisTutoriasPage.vue?vue&type=script&lang=js&"
import style0 from "./MisTutoriasPage.vue?vue&type=style&index=0&id=32af1cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af1cba",
  null
  
)

export default component.exports